export const sectionsStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
};
